module.exports = __webpack_public_path__ + "img/4.ba789888.png";